import React from 'react';
import config from 'react-global-configuration';

import OldQuote from './OldQuote';
import Quote from './Quote';

import { OF_DOMAIN, KP_DOMAIN, APPELTJES_DOMAIN } from '../../../config/constants';


const ParagraphQuote = (props) => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  // We keep the old component for the OF and KP domains, until migrated.
  // https://uncinc.monday.com/boards/420919839/pulses/8926347948.
  if (currentDomain === OF_DOMAIN || currentDomain === KP_DOMAIN || currentDomain === APPELTJES_DOMAIN) {
    return <OldQuote {...props} />;
  }

  return <Quote {...props} />;
};

export default ParagraphQuote;
